import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class OverquotaRestoreRequestAPICall extends APICallV4 {
    _method = 'overquota/restore';
    _type: Method = 'post';
}
